import styled from 'styled-components';
import { Banner } from 'ui/banner';
import { Body2, colors, spacing } from 'ui/theme';

export const StyledBanner = styled(Banner)`
  margin-bottom: ${spacing.plusHalf};
`;

export const OptionalFieldLabel = styled(Body2)`
  color: ${colors.textSecondary};
  margin-left: ${spacing.quarter};
`;
